import React from "react";

export default function TheadListInhabitant({
  access,
  idsToDelete,
  inhabitantSegments,
  setIdsToDelete,
}) {
  return (
    <thead>
      <tr>
        <th>Nome do Cliente</th>
        <th>CPF</th>
        <th>Assessor</th>
        <th>Segmento</th>
        <th>Loja do Assessor</th>
        <th>Data de Entrada</th>
        <th>Data de Saida</th>
        {access && (
          <>
            <th>Remover Cliente</th>
            <th>
              <input
                type="checkbox"
                className="checkbox"
                onChange={() => {
                  if (
                    !idsToDelete.length ||
                    idsToDelete.length < inhabitantSegments.length
                  ) {
                    setIdsToDelete(
                      inhabitantSegments.map(({ customer }) => customer.id)
                    );
                  } else {
                    setIdsToDelete([]);
                  }
                }}
                checked={
                  idsToDelete.length === inhabitantSegments.length &&
                  idsToDelete.length !== 0
                }
              />
            </th>
          </>
        )}
      </tr>
    </thead>
  );
}
